import type { TimezoneOption } from './timezonesApi';

/**
 * The zone list as it stood when this was bundled, shown until `GET /timezones` answers.
 *
 * Bundled rather than fetched-then-waited-for because the pickers built on it are searched
 * immediately and the list barely changes from one year to the next — and because a device that
 * is offline still has to be able to read the zone it is set to. The ids are the backend's own,
 * so a value picked from this list is the value the server would have given.
 */
export const TIMEZONE_PLACEHOLDER_DATA: TimezoneOption[] = [
  { id: '1', name: 'Africa/Abidjan' },
  { id: '2', name: 'Africa/Accra' },
  { id: '3', name: 'Africa/Addis_Ababa' },
  { id: '4', name: 'Africa/Algiers' },
  { id: '5', name: 'Africa/Asmara' },
  { id: '6', name: 'Africa/Asmera' },
  { id: '7', name: 'Africa/Bamako' },
  { id: '8', name: 'Africa/Bangui' },
  { id: '9', name: 'Africa/Banjul' },
  { id: '10', name: 'Africa/Bissau' },
  { id: '11', name: 'Africa/Blantyre' },
  { id: '12', name: 'Africa/Brazzaville' },
  { id: '13', name: 'Africa/Bujumbura' },
  { id: '14', name: 'Africa/Cairo' },
  { id: '15', name: 'Africa/Casablanca' },
  { id: '16', name: 'Africa/Ceuta' },
  { id: '17', name: 'Africa/Conakry' },
  { id: '18', name: 'Africa/Dakar' },
  { id: '19', name: 'Africa/Dar_es_Salaam' },
  { id: '20', name: 'Africa/Djibouti' },
  { id: '21', name: 'Africa/Douala' },
  { id: '22', name: 'Africa/El_Aaiun' },
  { id: '23', name: 'Africa/Freetown' },
  { id: '24', name: 'Africa/Gaborone' },
  { id: '25', name: 'Africa/Harare' },
  { id: '26', name: 'Africa/Johannesburg' },
  { id: '27', name: 'Africa/Kampala' },
  { id: '28', name: 'Africa/Khartoum' },
  { id: '29', name: 'Africa/Kigali' },
  { id: '30', name: 'Africa/Kinshasa' },
  { id: '31', name: 'Africa/Lagos' },
  { id: '32', name: 'Africa/Libreville' },
  { id: '33', name: 'Africa/Lome' },
  { id: '34', name: 'Africa/Luanda' },
  { id: '35', name: 'Africa/Lubumbashi' },
  { id: '36', name: 'Africa/Lusaka' },
  { id: '37', name: 'Africa/Malabo' },
  { id: '38', name: 'Africa/Maputo' },
  { id: '39', name: 'Africa/Maseru' },
  { id: '40', name: 'Africa/Mbabane' },
  { id: '41', name: 'Africa/Mogadishu' },
  { id: '42', name: 'Africa/Monrovia' },
  { id: '43', name: 'Africa/Nairobi' },
  { id: '44', name: 'Africa/Ndjamena' },
  { id: '45', name: 'Africa/Niamey' },
  { id: '46', name: 'Africa/Nouakchott' },
  { id: '47', name: 'Africa/Ouagadougou' },
  { id: '48', name: 'Africa/Porto-Novo' },
  { id: '49', name: 'Africa/Sao_Tome' },
  { id: '50', name: 'Africa/Timbuktu' },
  { id: '51', name: 'Africa/Tripoli' },
  { id: '52', name: 'Africa/Tunis' },
  { id: '53', name: 'Africa/Windhoek' },
  { id: '54', name: 'America/Adak' },
  { id: '55', name: 'America/Anchorage ' },
  { id: '56', name: 'America/Anguilla' },
  { id: '57', name: 'America/Antigua' },
  { id: '58', name: 'America/Araguaina' },
  { id: '59', name: 'America/Argentina/Buenos_Aires' },
  { id: '60', name: 'America/Argentina/Catamarca' },
  { id: '61', name: 'America/Argentina/ComodRivadavia' },
  { id: '62', name: 'America/Argentina/Cordoba' },
  { id: '63', name: 'America/Argentina/Jujuy' },
  { id: '64', name: 'America/Argentina/La_Rioja' },
  { id: '65', name: 'America/Argentina/Mendoza' },
  { id: '66', name: 'America/Argentina/Rio_Gallegos' },
  { id: '67', name: 'America/Argentina/Salta' },
  { id: '68', name: 'America/Argentina/San_Juan' },
  { id: '69', name: 'America/Argentina/San_Luis' },
  { id: '70', name: 'America/Argentina/Tucuman' },
  { id: '71', name: 'America/Argentina/Ushuaia' },
  { id: '72', name: 'America/Aruba' },
  { id: '73', name: 'America/Asuncion' },
  { id: '74', name: 'America/Atikokan' },
  { id: '75', name: 'America/Atka' },
  { id: '76', name: 'America/Bahia' },
  { id: '77', name: 'America/Barbados' },
  { id: '78', name: 'America/Belem' },
  { id: '79', name: 'America/Belize' },
  { id: '80', name: 'America/Blanc-Sablon' },
  { id: '81', name: 'America/Boa_Vista' },
  { id: '82', name: 'America/Bogota' },
  { id: '83', name: 'America/Boise' },
  { id: '84', name: 'America/Buenos_Aires' },
  { id: '85', name: 'America/Cambridge_Bay' },
  { id: '86', name: 'America/Campo_Grande' },
  { id: '87', name: 'America/Cancun' },
  { id: '88', name: 'America/Caracas' },
  { id: '89', name: 'America/Catamarca' },
  { id: '90', name: 'America/Cayenne' },
  { id: '91', name: 'America/Cayman' },
  { id: '92', name: 'America/Chicago' },
  { id: '93', name: 'America/Chihuahua' },
  { id: '94', name: 'America/Coral_Harbour' },
  { id: '95', name: 'America/Cordoba' },
  { id: '96', name: 'America/Costa_Rica' },
  { id: '97', name: 'America/Cuiaba' },
  { id: '98', name: 'America/Curacao' },
  { id: '99', name: 'America/Danmarkshavn' },
  { id: '100', name: 'America/Dawson' },
  { id: '101', name: 'America/Dawson_Creek' },
  { id: '102', name: 'America/Denver' },
  { id: '103', name: 'America/Detroit' },
  { id: '104', name: 'America/Dominica' },
  { id: '105', name: 'America/Edmonton' },
  { id: '106', name: 'America/Eirunepe' },
  { id: '107', name: 'America/El_Salvador' },
  { id: '108', name: 'America/Ensenada' },
  { id: '109', name: 'America/Fort_Wayne' },
  { id: '110', name: 'America/Fortaleza' },
  { id: '111', name: 'America/Glace_Bay' },
  { id: '112', name: 'America/Godthab' },
  { id: '113', name: 'America/Goose_Bay' },
  { id: '114', name: 'America/Grand_Turk' },
  { id: '115', name: 'America/Grenada' },
  { id: '116', name: 'America/Guadeloupe' },
  { id: '117', name: 'America/Guatemala' },
  { id: '118', name: 'America/Guayaquil' },
  { id: '119', name: 'America/Guyana' },
  { id: '120', name: 'America/Halifax' },
  { id: '121', name: 'America/Havana' },
  { id: '122', name: 'America/Hermosillo' },
  { id: '123', name: 'America/Indiana/Indianapolis' },
  { id: '124', name: 'America/Indiana/Knox' },
  { id: '125', name: 'America/Indiana/Marengo' },
  { id: '126', name: 'America/Indiana/Petersburg' },
  { id: '127', name: 'America/Indiana/Tell_City' },
  { id: '128', name: 'America/Indiana/Vevay' },
  { id: '129', name: 'America/Indiana/Vincennes' },
  { id: '130', name: 'America/Indiana/Winamac' },
  { id: '131', name: 'America/Indianapolis' },
  { id: '132', name: 'America/Inuvik' },
  { id: '133', name: 'America/Iqaluit' },
  { id: '134', name: 'America/Jamaica' },
  { id: '135', name: 'America/Jujuy' },
  { id: '136', name: 'America/Juneau' },
  { id: '137', name: 'America/Kentucky/Louisville' },
  { id: '138', name: 'America/Kentucky/Monticello' },
  { id: '139', name: 'America/Knox_IN' },
  { id: '140', name: 'America/La_Paz' },
  { id: '141', name: 'America/Lima' },
  { id: '142', name: 'America/Los_Angeles' },
  { id: '143', name: 'America/Louisville' },
  { id: '144', name: 'America/Maceio' },
  { id: '145', name: 'America/Managua' },
  { id: '146', name: 'America/Manaus' },
  { id: '147', name: 'America/Marigot' },
  { id: '148', name: 'America/Martinique' },
  { id: '149', name: 'America/Mazatlan' },
  { id: '150', name: 'America/Mendoza' },
  { id: '151', name: 'America/Menominee' },
  { id: '152', name: 'America/Merida' },
  { id: '153', name: 'America/Mexico_City' },
  { id: '154', name: 'America/Miquelon' },
  { id: '155', name: 'America/Moncton' },
  { id: '156', name: 'America/Monterrey' },
  { id: '157', name: 'America/Montevideo' },
  { id: '158', name: 'America/Montreal' },
  { id: '159', name: 'America/Montserrat' },
  { id: '160', name: 'America/Nassau' },
  { id: '161', name: 'America/New_York' },
  { id: '162', name: 'America/Nipigon' },
  { id: '163', name: 'America/Nome' },
  { id: '164', name: 'America/Noronha' },
  { id: '165', name: 'America/North_Dakota/Center' },
  { id: '166', name: 'America/North_Dakota/New_Salem' },
  { id: '167', name: 'America/Panama' },
  { id: '168', name: 'America/Pangnirtung' },
  { id: '169', name: 'America/Paramaribo' },
  { id: '170', name: 'America/Phoenix' },
  { id: '172', name: 'America/Port_of_Spain' },
  { id: '171', name: 'America/Port-au-Prince' },
  { id: '173', name: 'America/Porto_Acre' },
  { id: '174', name: 'America/Porto_Velho' },
  { id: '175', name: 'America/Puerto_Rico' },
  { id: '176', name: 'America/Rainy_River' },
  { id: '177', name: 'America/Rankin_Inlet' },
  { id: '178', name: 'America/Recife' },
  { id: '179', name: 'America/Regina' },
  { id: '180', name: 'America/Resolute' },
  { id: '181', name: 'America/Rio_Branco' },
  { id: '182', name: 'America/Rosario' },
  { id: '183', name: 'America/Santarem' },
  { id: '184', name: 'America/Santiago' },
  { id: '185', name: 'America/Santo_Domingo' },
  { id: '186', name: 'America/Sao_Paulo' },
  { id: '187', name: 'America/Scoresbysund' },
  { id: '188', name: 'America/Shiprock' },
  { id: '189', name: 'America/St_Barthelemy' },
  { id: '190', name: 'America/St_Johns' },
  { id: '191', name: 'America/St_Kitts' },
  { id: '192', name: 'America/St_Lucia' },
  { id: '193', name: 'America/St_Thomas' },
  { id: '194', name: 'America/St_Vincent' },
  { id: '195', name: 'America/Swift_Current' },
  { id: '196', name: 'America/Tegucigalpa' },
  { id: '197', name: 'America/Thule' },
  { id: '198', name: 'America/Thunder_Bay' },
  { id: '199', name: 'America/Tijuana' },
  { id: '200', name: 'America/Toronto' },
  { id: '201', name: 'America/Tortola' },
  { id: '202', name: 'America/Vancouver' },
  { id: '203', name: 'America/Virgin' },
  { id: '204', name: 'America/Whitehorse' },
  { id: '205', name: 'America/Winnipeg' },
  { id: '206', name: 'America/Yakutat' },
  { id: '207', name: 'America/Yellowknife' },
  { id: '208', name: 'Antarctica/Casey' },
  { id: '209', name: 'Antarctica/Davis' },
  { id: '210', name: 'Antarctica/DumontDUrville' },
  { id: '211', name: 'Antarctica/Mawson' },
  { id: '212', name: 'Antarctica/McMurdo' },
  { id: '213', name: 'Antarctica/Palmer' },
  { id: '214', name: 'Antarctica/Rothera' },
  { id: '215', name: 'Antarctica/South_Pole' },
  { id: '216', name: 'Antarctica/Syowa' },
  { id: '217', name: 'Antarctica/Vostok' },
  { id: '218', name: 'Arctic/Longyearbyen' },
  { id: '219', name: 'Asia/Aden' },
  { id: '220', name: 'Asia/Almaty' },
  { id: '221', name: 'Asia/Amman' },
  { id: '222', name: 'Asia/Anadyr' },
  { id: '223', name: 'Asia/Aqtau' },
  { id: '224', name: 'Asia/Aqtobe' },
  { id: '225', name: 'Asia/Ashgabat' },
  { id: '226', name: 'Asia/Ashkhabad' },
  { id: '227', name: 'Asia/Baghdad' },
  { id: '228', name: 'Asia/Bahrain' },
  { id: '229', name: 'Asia/Baku' },
  { id: '230', name: 'Asia/Bangkok' },
  { id: '231', name: 'Asia/Beirut' },
  { id: '232', name: 'Asia/Bishkek' },
  { id: '233', name: 'Asia/Brunei' },
  { id: '234', name: 'Asia/Calcutta' },
  { id: '235', name: 'Asia/Choibalsan' },
  { id: '236', name: 'Asia/Chongqing' },
  { id: '237', name: 'Asia/Chungking' },
  { id: '238', name: 'Asia/Colombo' },
  { id: '239', name: 'Asia/Dacca' },
  { id: '240', name: 'Asia/Damascus' },
  { id: '241', name: 'Asia/Dhaka' },
  { id: '242', name: 'Asia/Dili' },
  { id: '243', name: 'Asia/Dubai' },
  { id: '244', name: 'Asia/Dushanbe' },
  { id: '245', name: 'Asia/Gaza' },
  { id: '246', name: 'Asia/Harbin' },
  { id: '247', name: 'Asia/Ho_Chi_Minh' },
  { id: '248', name: 'Asia/Hong_Kong' },
  { id: '249', name: 'Asia/Hovd' },
  { id: '250', name: 'Asia/Irkutsk' },
  { id: '251', name: 'Asia/Istanbul' },
  { id: '252', name: 'Asia/Jakarta' },
  { id: '253', name: 'Asia/Jayapura' },
  { id: '254', name: 'Asia/Jerusalem' },
  { id: '255', name: 'Asia/Kabul' },
  { id: '256', name: 'Asia/Kamchatka' },
  { id: '257', name: 'Asia/Karachi' },
  { id: '258', name: 'Asia/Kashgar' },
  { id: '259', name: 'Asia/Kathmandu' },
  { id: '260', name: 'Asia/Katmandu' },
  { id: '261', name: 'Asia/Kolkata' },
  { id: '262', name: 'Asia/Krasnoyarsk' },
  { id: '263', name: 'Asia/Kuala_Lumpur' },
  { id: '264', name: 'Asia/Kuching' },
  { id: '265', name: 'Asia/Kuwait' },
  { id: '266', name: 'Asia/Macao' },
  { id: '267', name: 'Asia/Macau' },
  { id: '268', name: 'Asia/Magadan' },
  { id: '269', name: 'Asia/Makassar' },
  { id: '270', name: 'Asia/Manila' },
  { id: '271', name: 'Asia/Muscat' },
  { id: '272', name: 'Asia/Nicosia' },
  { id: '273', name: 'Asia/Novosibirsk' },
  { id: '274', name: 'Asia/Omsk' },
  { id: '275', name: 'Asia/Oral' },
  { id: '276', name: 'Asia/Phnom_Penh' },
  { id: '277', name: 'Asia/Pontianak' },
  { id: '278', name: 'Asia/Pyongyang' },
  { id: '279', name: 'Asia/Qatar' },
  { id: '280', name: 'Asia/Qyzylorda' },
  { id: '281', name: 'Asia/Rangoon' },
  { id: '282', name: 'Asia/Riyadh' },
  { id: '283', name: 'Asia/Saigon' },
  { id: '284', name: 'Asia/Sakhalin' },
  { id: '285', name: 'Asia/Samarkand' },
  { id: '286', name: 'Asia/Seoul' },
  { id: '287', name: 'Asia/Shanghai' },
  { id: '288', name: 'Asia/Singapore' },
  { id: '289', name: 'Asia/Taipei' },
  { id: '290', name: 'Asia/Tashkent' },
  { id: '291', name: 'Asia/Tbilisi' },
  { id: '292', name: 'Asia/Tehran' },
  { id: '293', name: 'Asia/Tel_Aviv' },
  { id: '294', name: 'Asia/Thimbu' },
  { id: '295', name: 'Asia/Thimphu' },
  { id: '296', name: 'Asia/Tokyo' },
  { id: '297', name: 'Asia/Ujung_Pandang' },
  { id: '298', name: 'Asia/Ulaanbaatar' },
  { id: '299', name: 'Asia/Ulan_Bator' },
  { id: '300', name: 'Asia/Urumqi' },
  { id: '301', name: 'Asia/Vientiane' },
  { id: '302', name: 'Asia/Vladivostok' },
  { id: '303', name: 'Asia/Yakutsk' },
  { id: '304', name: 'Asia/Yekaterinburg' },
  { id: '305', name: 'Asia/Yerevan' },
  { id: '306', name: 'Atlantic/Azores' },
  { id: '307', name: 'Atlantic/Bermuda' },
  { id: '308', name: 'Atlantic/Canary' },
  { id: '309', name: 'Atlantic/Cape_Verde' },
  { id: '310', name: 'Atlantic/Faeroe' },
  { id: '311', name: 'Atlantic/Faroe' },
  { id: '312', name: 'Atlantic/Jan_Mayen' },
  { id: '313', name: 'Atlantic/Madeira' },
  { id: '314', name: 'Atlantic/Reykjavik' },
  { id: '315', name: 'Atlantic/South_Georgia' },
  { id: '316', name: 'Atlantic/St_Helena' },
  { id: '317', name: 'Atlantic/Stanley' },
  { id: '318', name: 'Australia/ACT' },
  { id: '319', name: 'Australia/Adelaide' },
  { id: '320', name: 'Australia/Brisbane' },
  { id: '321', name: 'Australia/Broken_Hill' },
  { id: '322', name: 'Australia/Canberra' },
  { id: '323', name: 'Australia/Currie' },
  { id: '324', name: 'Australia/Darwin' },
  { id: '325', name: 'Australia/Eucla' },
  { id: '326', name: 'Australia/Hobart' },
  { id: '327', name: 'Australia/LHI' },
  { id: '328', name: 'Australia/Lindeman' },
  { id: '329', name: 'Australia/Lord_Howe' },
  { id: '330', name: 'Australia/Melbourne' },
  { id: '331', name: 'Australia/North' },
  { id: '332', name: 'Australia/NSW' },
  { id: '333', name: 'Australia/Perth' },
  { id: '334', name: 'Australia/Queensland' },
  { id: '335', name: 'Australia/South' },
  { id: '336', name: 'Australia/Sydney' },
  { id: '337', name: 'Australia/Tasmania' },
  { id: '338', name: 'Australia/Victoria' },
  { id: '339', name: 'Australia/West' },
  { id: '340', name: 'Australia/Yancowinna' },
  { id: '450', name: 'Brazil/Acre' },
  { id: '451', name: 'Brazil/DeNoronha' },
  { id: '452', name: 'Brazil/East' },
  { id: '453', name: 'Brazil/West' },
  { id: '454', name: 'Canada/Atlantic' },
  { id: '455', name: 'Canada/Central' },
  { id: '456', name: 'Canada/East-Saskatchewan' },
  { id: '457', name: 'Canada/Eastern' },
  { id: '458', name: 'Canada/Mountain' },
  { id: '459', name: 'Canada/Newfoundland' },
  { id: '460', name: 'Canada/Pacific' },
  { id: '461', name: 'Canada/Saskatchewan' },
  { id: '462', name: 'Canada/Yukon' },
  { id: '463', name: 'CET' },
  { id: '464', name: 'Chile/Continental' },
  { id: '465', name: 'Chile/EasterIsland' },
  { id: '466', name: 'CST6CDT' },
  { id: '467', name: 'Cuba' },
  { id: '468', name: 'EET' },
  { id: '469', name: 'Egypt' },
  { id: '470', name: 'Eire' },
  { id: '471', name: 'EST' },
  { id: '472', name: 'EST5EDT' },
  { id: '473', name: 'Etc/GMT' },
  { id: '487', name: 'Etc/GMT-0' },
  { id: '488', name: 'Etc/GMT-1' },
  { id: '489', name: 'Etc/GMT-10' },
  { id: '490', name: 'Etc/GMT-11' },
  { id: '491', name: 'Etc/GMT-12' },
  { id: '492', name: 'Etc/GMT-13' },
  { id: '493', name: 'Etc/GMT-14' },
  { id: '494', name: 'Etc/GMT-2' },
  { id: '495', name: 'Etc/GMT-3' },
  { id: '496', name: 'Etc/GMT-4' },
  { id: '497', name: 'Etc/GMT-5' },
  { id: '498', name: 'Etc/GMT-6' },
  { id: '499', name: 'Etc/GMT-7' },
  { id: '500', name: 'Etc/GMT-8' },
  { id: '501', name: 'Etc/GMT-9' },
  { id: '474', name: 'Etc/GMT+0' },
  { id: '475', name: 'Etc/GMT+1' },
  { id: '476', name: 'Etc/GMT+10' },
  { id: '477', name: 'Etc/GMT+11' },
  { id: '478', name: 'Etc/GMT+12' },
  { id: '479', name: 'Etc/GMT+2' },
  { id: '480', name: 'Etc/GMT+3' },
  { id: '481', name: 'Etc/GMT+4' },
  { id: '482', name: 'Etc/GMT+5' },
  { id: '483', name: 'Etc/GMT+6' },
  { id: '484', name: 'Etc/GMT+7' },
  { id: '485', name: 'Etc/GMT+8' },
  { id: '486', name: 'Etc/GMT+9' },
  { id: '502', name: 'Etc/GMT0' },
  { id: '503', name: 'Etc/Greenwich' },
  { id: '504', name: 'Etc/UCT' },
  { id: '505', name: 'Etc/Universal' },
  { id: '506', name: 'Etc/UTC' },
  { id: '507', name: 'Etc/Zulu' },
  { id: '341', name: 'Europe/Amsterdam' },
  { id: '342', name: 'Europe/Andorra' },
  { id: '343', name: 'Europe/Athens' },
  { id: '344', name: 'Europe/Belfast' },
  { id: '345', name: 'Europe/Belgrade' },
  { id: '346', name: 'Europe/Berlin' },
  { id: '347', name: 'Europe/Bratislava' },
  { id: '348', name: 'Europe/Brussels' },
  { id: '349', name: 'Europe/Bucharest' },
  { id: '350', name: 'Europe/Budapest' },
  { id: '351', name: 'Europe/Chisinau' },
  { id: '352', name: 'Europe/Copenhagen' },
  { id: '353', name: 'Europe/Dublin' },
  { id: '354', name: 'Europe/Gibraltar' },
  { id: '355', name: 'Europe/Guernsey' },
  { id: '356', name: 'Europe/Helsinki' },
  { id: '357', name: 'Europe/Isle_of_Man' },
  { id: '358', name: 'Europe/Istanbul' },
  { id: '359', name: 'Europe/Jersey' },
  { id: '360', name: 'Europe/Kaliningrad' },
  { id: '361', name: 'Europe/Kiev' },
  { id: '362', name: 'Europe/Lisbon' },
  { id: '363', name: 'Europe/Ljubljana' },
  { id: '364', name: 'Europe/London' },
  { id: '365', name: 'Europe/Luxembourg' },
  { id: '366', name: 'Europe/Madrid' },
  { id: '367', name: 'Europe/Malta' },
  { id: '368', name: 'Europe/Mariehamn' },
  { id: '369', name: 'Europe/Minsk' },
  { id: '370', name: 'Europe/Monaco' },
  { id: '371', name: 'Europe/Moscow' },
  { id: '372', name: 'Europe/Nicosia' },
  { id: '373', name: 'Europe/Oslo' },
  { id: '374', name: 'Europe/Paris' },
  { id: '375', name: 'Europe/Podgorica' },
  { id: '376', name: 'Europe/Prague' },
  { id: '377', name: 'Europe/Riga' },
  { id: '378', name: 'Europe/Rome' },
  { id: '379', name: 'Europe/Samara' },
  { id: '380', name: 'Europe/San_Marino' },
  { id: '381', name: 'Europe/Sarajevo' },
  { id: '382', name: 'Europe/Simferopol' },
  { id: '383', name: 'Europe/Skopje' },
  { id: '384', name: 'Europe/Sofia' },
  { id: '385', name: 'Europe/Stockholm' },
  { id: '386', name: 'Europe/Tallinn' },
  { id: '387', name: 'Europe/Tirane' },
  { id: '388', name: 'Europe/Tiraspol' },
  { id: '389', name: 'Europe/Uzhgorod' },
  { id: '390', name: 'Europe/Vaduz' },
  { id: '391', name: 'Europe/Vatican' },
  { id: '392', name: 'Europe/Vienna' },
  { id: '393', name: 'Europe/Vilnius' },
  { id: '394', name: 'Europe/Volgograd' },
  { id: '395', name: 'Europe/Warsaw' },
  { id: '396', name: 'Europe/Zagreb' },
  { id: '397', name: 'Europe/Zaporozhye' },
  { id: '398', name: 'Europe/Zurich' },
  { id: '508', name: 'Factory' },
  { id: '509', name: 'GB' },
  { id: '510', name: 'GB-Eire' },
  { id: '511', name: 'GMT' },
  { id: '513', name: 'GMT-0' },
  { id: '512', name: 'GMT+0' },
  { id: '514', name: 'GMT0' },
  { id: '515', name: 'Greenwich' },
  { id: '516', name: 'Hongkong' },
  { id: '517', name: 'HST' },
  { id: '518', name: 'Iceland' },
  { id: '399', name: 'Indian/Antananarivo' },
  { id: '400', name: 'Indian/Chagos' },
  { id: '401', name: 'Indian/Christmas' },
  { id: '402', name: 'Indian/Cocos' },
  { id: '403', name: 'Indian/Comoro' },
  { id: '404', name: 'Indian/Kerguelen' },
  { id: '405', name: 'Indian/Mahe' },
  { id: '406', name: 'Indian/Maldives' },
  { id: '407', name: 'Indian/Mauritius' },
  { id: '408', name: 'Indian/Mayotte' },
  { id: '409', name: 'Indian/Reunion' },
  { id: '519', name: 'Iran' },
  { id: '520', name: 'Israel' },
  { id: '521', name: 'Jamaica' },
  { id: '522', name: 'Japan' },
  { id: '523', name: 'Kwajalein' },
  { id: '524', name: 'Libya' },
  { id: '525', name: 'MET' },
  { id: '526', name: 'Mexico/BajaNorte' },
  { id: '527', name: 'Mexico/BajaSur' },
  { id: '528', name: 'Mexico/General' },
  { id: '529', name: 'MST' },
  { id: '530', name: 'MST7MDT' },
  { id: '531', name: 'Navajo' },
  { id: '532', name: 'NZ' },
  { id: '533', name: 'NZ-CHAT' },
  { id: '410', name: 'Pacific/Apia' },
  { id: '411', name: 'Pacific/Auckland' },
  { id: '412', name: 'Pacific/Chatham' },
  { id: '413', name: 'Pacific/Easter' },
  { id: '414', name: 'Pacific/Efate' },
  { id: '415', name: 'Pacific/Enderbury' },
  { id: '416', name: 'Pacific/Fakaofo' },
  { id: '417', name: 'Pacific/Fiji' },
  { id: '418', name: 'Pacific/Funafuti' },
  { id: '419', name: 'Pacific/Galapagos' },
  { id: '420', name: 'Pacific/Gambier' },
  { id: '421', name: 'Pacific/Guadalcanal' },
  { id: '422', name: 'Pacific/Guam' },
  { id: '423', name: 'Pacific/Honolulu' },
  { id: '424', name: 'Pacific/Johnston' },
  { id: '425', name: 'Pacific/Kiritimati' },
  { id: '426', name: 'Pacific/Kosrae' },
  { id: '427', name: 'Pacific/Kwajalein' },
  { id: '428', name: 'Pacific/Majuro' },
  { id: '429', name: 'Pacific/Marquesas' },
  { id: '430', name: 'Pacific/Midway' },
  { id: '431', name: 'Pacific/Nauru' },
  { id: '432', name: 'Pacific/Niue' },
  { id: '433', name: 'Pacific/Norfolk' },
  { id: '434', name: 'Pacific/Noumea' },
  { id: '435', name: 'Pacific/Pago_Pago' },
  { id: '436', name: 'Pacific/Palau' },
  { id: '437', name: 'Pacific/Pitcairn' },
  { id: '438', name: 'Pacific/Ponape' },
  { id: '439', name: 'Pacific/Port_Moresby' },
  { id: '440', name: 'Pacific/Rarotonga' },
  { id: '441', name: 'Pacific/Saipan' },
  { id: '442', name: 'Pacific/Samoa' },
  { id: '443', name: 'Pacific/Tahiti' },
  { id: '444', name: 'Pacific/Tarawa' },
  { id: '445', name: 'Pacific/Tongatapu' },
  { id: '446', name: 'Pacific/Truk' },
  { id: '447', name: 'Pacific/Wake' },
  { id: '448', name: 'Pacific/Wallis' },
  { id: '449', name: 'Pacific/Yap' },
  { id: '534', name: 'Poland' },
  { id: '535', name: 'Portugal' },
  { id: '536', name: 'PRC' },
  { id: '537', name: 'PST8PDT' },
  { id: '538', name: 'ROC' },
  { id: '539', name: 'ROK' },
  { id: '540', name: 'Singapore' },
  { id: '541', name: 'Turkey' },
  { id: '542', name: 'UCT' },
  { id: '543', name: 'Universal' },
  { id: '544', name: 'US/Alaska' },
  { id: '545', name: 'US/Aleutian' },
  { id: '546', name: 'US/Arizona' },
  { id: '547', name: 'US/Central' },
  { id: '548', name: 'US/East-Indiana' },
  { id: '549', name: 'US/Eastern' },
  { id: '550', name: 'US/Hawaii' },
  { id: '551', name: 'US/Indiana-Starke' },
  { id: '552', name: 'US/Michigan' },
  { id: '553', name: 'US/Mountain' },
  { id: '554', name: 'US/Pacific' },
  { id: '555', name: 'US/Pacific-New' },
  { id: '556', name: 'US/Samoa' },
  { id: '557', name: 'UTC' },
  { id: '558', name: 'W-SU' },
  { id: '559', name: 'WET' },
  { id: '560', name: 'Zulu' },
];
